import React, { Suspense } from "react";
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  useNavigate,
} from "react-router-dom";
import { AxiosInterceptor } from "../components/general/AxiosInterceptor";
import PTNetworkErrorPage from "../components/ui/PTNetworkErrorPage";
import PTNotFoundErrorPage from "../components/ui/PTNotFoundErrorPage";
import PTServeurErrorPage from "../components/ui/PTServeurErrorPage";
import {
  NETWORK_ERROR_PAGE_ROUTE,
  NOT_FOUND_ERROR_PAGE_ROUTE,
  SERVER_ERROR_PAGE_ROUTE,
} from "../constants/routerConstants";
import SecureNavBar from "../navbar/Secure";
import { getPrivateRoutes } from "./privateRoutes";
import {Loading} from "../components/ui";
import { flattenArray } from "../utils/appUtils";
import JWtUtils from "../utils/JWtUtils";
import ChangePasswordDialog from "../../modules/settings/components/ChangePasswordDialog";

const ErrorPageContainer = ({ children }) => {
  const navigate = useNavigate();
  const retourHandler = () => {
    navigate(-1);
  };
  return React.cloneElement(children, {
    onRetour: retourHandler,
  });
};

const AppMainContainer = () => {
  return (
    <SecureNavBar>
    <ChangePasswordDialog />      
      <div
        style={{
          marginTop: "10px",
          marginLeft: "20px",
          width: "calc(100% - 30px)",
        }}
      >
        <AxiosInterceptor>
          <Outlet />
        </AxiosInterceptor>
      </div>
    </SecureNavBar>
  );
};

export const secureRouter = createBrowserRouter([
  { path: "*", element: <Navigate to={NOT_FOUND_ERROR_PAGE_ROUTE} replace /> },
  {
    path: "/",
    element: <AppMainContainer />,
    exact: true,
    children: [
      // Routes de bases
      {
        path: SERVER_ERROR_PAGE_ROUTE,
        element: (
          <ErrorPageContainer>
            <PTServeurErrorPage />
          </ErrorPageContainer>
        ),
        exact: true,
      },
      {
        path: NOT_FOUND_ERROR_PAGE_ROUTE,
        element: (
          <ErrorPageContainer>
            <PTNotFoundErrorPage />
          </ErrorPageContainer>
        ),
        exact: true,
      },
      {
        path: NETWORK_ERROR_PAGE_ROUTE,
        element: (
          <ErrorPageContainer>
            <PTNetworkErrorPage />
          </ErrorPageContainer>
        ),
        exact: true,
      },
      // Custom Routes
      ...flattenArray(getPrivateRoutes().filter(r => JWtUtils.hasAnyRole(r.roles)), ["path", "component"]).map(
        (r) => ({
          path: r.path,
          element: (
            <Suspense fallback={<Loading />}>
              <r.component />
            </Suspense>
          ),
        })
      ), 
    ],
  },
]);

export default secureRouter;
